import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { LoginService } from '../../services/login.service';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-first-connexion',
  templateUrl: './first-connexion.component.html',
  styleUrls: ['./first-connexion.component.css'],
  standalone: false
})
export class FirstConnexionComponent implements OnInit {

  firstConnexionForm: FormGroup;
  control: FormControl;
  firstConnexionFormSubmitted: boolean;
  multipleAccount: boolean;
  email: string;
  environment = environment;
  brand?: string;
  vitrineUrl?: string;

  breadcrumbDetails: any = [
    {
      url: environment.data.vitrineUrl,
      label: `Accueil`
    },
    {
      url: `/connexion`,
      label: `Identification`
    },
    {
      url: null,
      label: `Première connexion`
    }
  ];

  constructor(
      private store: Store<any>,
      private router: Router,
      private formBuilder: FormBuilder,
      private loginService: LoginService,
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.vitrineUrl = environment.data.vitrineUrl;
    this.firstConnexionFormSubmitted = false;
    this.multipleAccount = false;
    this.email = null;
    this.initForms();
  }

  initForms() {
    this.control = this.formBuilder.control('', Validators.required);
    this.firstConnexionForm = this.formBuilder.group({});
    this.firstConnexionForm.addControl('msisdn', this.formBuilder.control('', [Validators.pattern('^(\\+33|0)[6-7][0-9]{8}$')]));
  }

  send() {
    this.firstConnexionFormSubmitted = true;
    if (this.firstConnexionForm.valid) {
      this.firstConnexionFormSubmitted = false;
      this.loginService.generatePassword(this.firstConnexionForm.get('msisdn').value).subscribe(
          response => {
            const alertMessage = {message: 'Votre mot de passe a été envoyé par SMS', code: 200} as AlertMessageInterface;
            this.store.dispatch(new GetAlertMessage(alertMessage));
            this.router.navigate(['/connexion/' + this.firstConnexionForm.get('msisdn').value]);
          }, error => {
            const alertMessage = {message: ConstsHelper.ERROR_OCCURRED_RETRY_MESSAGE, code: 400} as AlertMessageInterface;
            this.store.dispatch(new GetAlertMessage(alertMessage));
          }
      );
    }
  }
}
